// assets
import PrivacyTip from '@mui/icons-material/PrivacyTip';

import LocalPoliceSharpIcon from '@mui/icons-material/LocalPoliceSharp';
import StorefrontIcon from '@mui/icons-material/Storefront';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import StraightenIcon from '@mui/icons-material/Straighten';
// constant
const icons = {
  PrivacyTip,
  LocalPoliceSharpIcon,
  StorefrontIcon,
  CategoryOutlinedIcon,
  StraightenIcon
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const app_content = {
  id: 'app-content',
  title: 'App Content',

  type: 'group',
  userRoles: ['Super Admin'],
  children: [
    {
      check: 'view-privacy-policy',
      id: 'app-privacy-policy',
      title: 'Privacy Policy',
      type: 'item',
      url: '/privacy-policy',
      icon: icons.PrivacyTip,
      breadcrumbs: false
    },
    {
      check: 'view-terms-and-conditions',
      id: 'terms',
      title: 'Terms And Conditions',
      type: 'item',
      url: '/terms',
      icon: icons.LocalPoliceSharpIcon,
      breadcrumbs: false
    },
    {
      check: 'view-brands',
      id: 'brands-hub',
      title: 'Brands',
      type: 'collapse',
      icon: icons.StorefrontIcon,
      children: [
        {
          check: 'view-brands',
          id: 'brands',
          title: 'All Brands',
          type: 'item',
          url: '/brands',
          icon: icons.StorefrontIcon,
          breadcrumbs: false
        },
        {
          check: 'view-brands',
          id: 'categories-mgmt',
          title: 'Categories',
          type: 'item',
          url: '/categories',
          icon: icons.CategoryOutlinedIcon,
          breadcrumbs: false
        },
        {
          check: 'view-sizes',
          id: 'sizing',
          title: 'Sizing',
          type: 'item',
          url: '/sizes',
          icon: icons.StraightenIcon,
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default app_content;
